import type { ExamFormTestProm, Question } from "@rmh/defs";
import { Prom, TestKey } from "@rmh/defs";
import { defaults, PROM_TEST_TITLE_PREFIX } from "./defaults";
import { lowerExtremityFunctionalScaleEn } from "./en/lowerExtremityFunctionalScale";
import { lowerExtremityFunctionalScaleEs } from "./es/lowerExtremityFunctionalScale";

const createProm = (locale: string): ExamFormTestProm => {
  const translations =
    locale === "es"
      ? lowerExtremityFunctionalScaleEs
      : lowerExtremityFunctionalScaleEn;

  return {
    promName: "Lower Extremity Functional Scale (LEFS)",
    promBodyRegion: Prom.LowerExtremityFunctionalScale,
    redToGreen: true,
    startAt: 0,
    updatedAt: new Date().toISOString(),
    testKey: TestKey.LowerExtremityFunctionalScale,
    testTitle: `${PROM_TEST_TITLE_PREFIX} - Lower Extremity Functional Scale (LEFS)`,
    questions: translations.questions.map((text) => ({
      text,
      scaleLabels: translations.scaleLabels,
      scaleStartLabel: translations.scaleStartLabel,
      scaleEndLabel: translations.scaleEndLabel,
      promInstructions: translations.promInstructions,
    })),
  };
};

export const lowerExtremityFunctionalScaleProm = {
  ...defaults,
  examFormTests: [
    {
      __typename: "ExamFormTestProm",
      ...createProm("en"), // Default to English
    },
  ],
};

export const getLowerExtremityFunctionalScaleProm = (locale: string = "en") => {
  return {
    ...defaults,
    examFormTests: [
      {
        __typename: "ExamFormTestProm",
        ...createProm(locale),
      },
    ],
  };
};

export const lowerExtremityFunctionalScaleCalculations = (
  questions: Question[]
) => {
  const sum = questions.reduce((reducer, question) => {
    const score = question.userAnswer ?? 0;

    return score + reducer;
  }, 0);

  return sum; // The actual percentage calculation is calculated on display
};
